import React from 'react';
import { Table, Button, Container } from 'react-bootstrap';
import { API_BASE } from "../api";

function ParticipantsList({ participants = [], max, onDelete }) {
  const items = typeof max === 'number' ? participants.slice(0, max) : participants;

  const downloadPhoto = async (fileName, participantId) => {
    if (!fileName) return;
    try {
      const response = await fetch(`${API_BASE}/uploads/${fileName}`);
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const ext = fileName.split('.').pop();
      const idPart = participantId ? String(participantId).replace(/[^a-z0-9_\\-\\.]/gi, '_') : 'photo';
      const suggestedName = `${idPart}.${ext}`;
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = suggestedName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('Error downloading photo:', error);
      alert('Er is een fout opgetreden bij het downloaden van de foto.');
    }
  };

  return (
    <Container className="mt-4">
      <h2>Participant list</h2>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Photo</th>
            <th>Name</th>
            <th>Birthdate</th>
            <th>Registration time</th>
            {onDelete ? <th>Actions</th> : null}
          </tr>
        </thead>
        <tbody>
          {items.map((participant) => (
            <tr key={participant.id}>
              <td>{participant.id}</td>
              <td>
                {participant.profielfoto ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img
                      src={`${API_BASE}/uploads/${participant.profielfoto}`}
                      alt="Profile photo"
                      style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
                    />
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={() => downloadPhoto(participant.profielfoto, participant.id)}
                    >
                      Download photo
                    </Button>
                  </div>
                ) : (
                  <span>—</span>
                )}
              </td>
              <td>{participant.naam}</td>
              <td>{participant.geboortedatum ? new Date(participant.geboortedatum).toLocaleDateString('en-GB') : ''}</td>
              <td>{participant.registratietijd ? new Date(participant.registratietijd).toLocaleTimeString('en-GB') : ''}</td>
              {onDelete ? (
                <td>
                  <Button variant="danger" onClick={() => onDelete(participant.id, participant.naam)}>Delete</Button>
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default ParticipantsList;
